import React, { useState } from "react";
import { Table, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const data = [
  {
    key: "1",
    sno: "01",
    month: "June",
    fileid: "KARWAR",
    totalmspc: "1200",
    planned: "200 T",
    actuals: "180 T",
    difference: "20 t",
    finalcount: "20 t",
    status: "Pending",
  },
  {
    key: "2",
    sno: "02",
    month: "June",
    fileid: "KARWAR",
    totalmspc: "1200",
    planned: "200 T",
    actuals: "180 T",
    difference: "20 t",
    finalcount: "20 t",
    status: "Completed",
  },
];

const PO_Page = () => {
  const [searchText, setSearchText] = useState("");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const navigate = useNavigate();

  const handleStatusClick = (record) => {
    if (record.status === "Pending") {
      navigate("/master/purchase/po-pagetwo", { state: { record } });
    }
  };

  const columns = [
    { title: "S.No", dataIndex: "sno", key: "sno" },
    { title: "Month", dataIndex: "month", key: "month" },
    { title: "File ID", dataIndex: "fileid", key: "fileid" },
    { title: "Total MSPC", dataIndex: "totalmspc", key: "totalmspc" },
    { title: "Planned", dataIndex: "planned", key: "planned" },
    { title: "Actuals", dataIndex: "actuals", key: "actuals" },
    { title: "Difference", dataIndex: "difference", key: "difference" },
    { title: "Final Count", dataIndex: "finalcount", key: "finalcount" },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status, record) => (
        <span
          onClick={() => handleStatusClick(record)}
          style={{
            cursor: "pointer",
            color: "#063253",
            backgroundColor: status === "Pending" ? "#A7CCF2" : "#A1FF5A",
            borderRadius: "20px",
            padding: "2px 16px",
            fontWeight: 500,
            fontSize: "13px",
            display: "inline-block",
          }}
        >
          {status}
        </span>
      ),
    },
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys) => {
      setSelectedRowKeys(newSelectedRowKeys);
    },
  };

  const filteredData = data.filter(
    (item) =>
      item.fileid.toLowerCase().includes(searchText.toLowerCase()) ||
      item.totalmspc.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <div
      style={{
        padding: "30px",
        background: "#F5F7FB",
        borderRadius: "10px",
      }}
    >
      <h3 style={{ marginBottom: 10 }}>Recent File</h3>
      <Input
        placeholder="Search by Name or MSPC"
        prefix={<SearchOutlined />}
        style={{ width: "50%", marginBottom: 16, borderRadius: "15px" }}
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />
      <Table
        rowSelection={rowSelection}
        columns={columns}
        dataSource={filteredData}
        size="small"
        bordered
        pagination={false}
        rowKey="key"
      />
    </div>
  );
};

export default PO_Page;
